import React, { FC, MouseEvent } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { panelSelectOpened } from "../../../../reduxFolder/selectors/rightPanelSelectors";
import {
  TableCol,
  TableRow,
  WrapperRecipientItemRow,
} from "../../styles/BookRecipients.style";

interface BooksPassportItemRowProps {
  item: any;
  disabled: boolean;
  onFocusPassportItemInPanel: (e: MouseEvent, item: any) => void;
  isPanelOpened: boolean;
  selectedPassportId: number | null;
}

const BooksPassportItemRow: FC<BooksPassportItemRowProps> = React.memo(
  ({
    item,
    disabled,
    onFocusPassportItemInPanel,
    isPanelOpened,
    selectedPassportId,
  }) => {
    const fullName = item.get("full_name");
    const serial = item.get("serial");
    const number = item.get("number");
    const taxId = item.get("tax_id");
    const issuedDate = item.get("issued_date");

    const isSelected =
      isPanelOpened && selectedPassportId === item.get("id");

    return (
      <WrapperRecipientItemRow disabled={disabled}>
        <TableRow
          onClick={(e) => onFocusPassportItemInPanel(e, item)}
          selected={!!isSelected}
        >
          <TableCol xs={6} md={3}>
            {fullName}
          </TableCol>
          <TableCol xs={6} md={3}>
            {serial} {number}
          </TableCol>
          <TableCol xs={6} md={3}>
            {taxId}
          </TableCol>
          <TableCol xs={6} md={3}>
            {issuedDate}
          </TableCol>
        </TableRow>
      </WrapperRecipientItemRow>
    );
  },
);

const withConnect = connect(
  createStructuredSelector({
    isPanelOpened: panelSelectOpened,
  }),
);

export default withConnect(BooksPassportItemRow);
